import { Signal } from 'typed-signals';
import type { Popup } from '../../../popups/Popup';
import { UpsellPopupLayout } from '../../../../layouts/popups/UpsellPopupLayout';
import type { UpsellInventoryView } from '../../../mainMenu/shopPage/UpsellInventoryView';

interface UpsellPopupConfig {
  upsellInventoryView: UpsellInventoryView;
}

export class UpsellPopup implements Popup {
  public readonly onRequestFullShop = new Signal();

  public readonly onCloseButtonClicked = new Signal();

  private readonly layout = new UpsellPopupLayout();

  public readonly root = this.layout.root;

  public readonly onEvent = new Signal<(event: string) => void>();

  set interactive(value: boolean) {
    this.root.interactiveChildren = value;
  }

  constructor({ upsellInventoryView }: UpsellPopupConfig) {
    const { closeButton, moreOffersButton } = this.layout;

    closeButton.on('pointertap', () => {
      this.onCloseButtonClicked.emit();
    });

    moreOffersButton.on('pointertap', () => {
      this.onRequestFullShop.emit();
    });

    upsellInventoryView.props({
      parent: this.layout.upsellSlot,
    });
  }

  public onAdded(): void {
    this.root.tweenFrom({ alpha: 0 }, 300, 'sinIn', true);
  }
}
